import component from './block';

export default {
	component,
	getChildren: record => [ ...record.button, ...record.content ]
}

